module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[58]545.b636800.woff2";